import * as t from 'io-ts';
import { optional } from './helper';

const navigationExtraSport = t.type({
  name: t.string,
  image: optional(t.string),
  id: t.string,
  classification: optional(t.string),
  sport: t.string,
});

const navigationSportTournament = t.type({
  name: t.string,
  image: t.string,
  id: t.string,
  classification: optional(t.string),
  sport: t.string,
  providerId: t.string,
  legacyId: t.string,
});
export type NavigationSportTournament = t.TypeOf<typeof navigationSportTournament>;

const navigationSportGroup = t.type({
  name: t.string,
  image: t.string,
  children: t.array(navigationSportTournament),
});
export type NavigationSportGroup = t.TypeOf<typeof navigationSportGroup>;

const navigationSport = t.type({
  name: t.string,
  image: t.string,
  id: t.string,
  sport: t.keyof({ football: 0, rugby: 0, cricket: 0, golf: 0, motorsport: 0, tennis: 0, athletics: 0, cycling: 0, boxing: 0, wrestling: 0, aquatics: 0}),
  classification: optional(t.string),
  children: t.array(t.union([navigationSportGroup, navigationSportTournament])),
});
export type NavigationSport = t.TypeOf<typeof navigationSport>;

export const navigationApiResponse = t.array(t.union([navigationSport, navigationExtraSport]));
export type Navigation = t.TypeOf<typeof navigationApiResponse>;
